import React, { useEffect } from 'react';
import { Rectangle } from 'recharts';
export const Cursor = ({ setHoveredColumn, ...props }) => {
    useEffect(() => {
        setHoveredColumn(props);
        return function clear() {
            setHoveredColumn(null);
        };
    }, [props.x]);
    return React.createElement(Rectangle, { ...props });
};
